const _SETTINGS = {
    saveVersion: 1,
    player_name: 'RUiN',
    metris_amount: 0,
    metris_click_value: 1,
    player_level: 0,
    metris_player_click_counter: 0,
    metris_player_click_frequency: 0,
    metris_per_second_value: 0,
    metris_gold_click_chance: 0.001,
    metris_gold_click_value: 1000,
    metris_gold_click_counter: 0,
    metris_gold_time_chance: 0.0008,
    metris_gold_time_value: 600,
    metris_gold_time_counter: 0,
    metris_gold_time_duration: 10,
    notification_show: false,
    items_buy_counter: 0,
    stick_buy_counter: 0,
    monk_buy_counter: 0,
    book_buy_counter: 0,
    temple_buy_counter: 0,
    jesus_buy_counter: 0,
    jew_buy_counter: 0,
    islam_buy_counter: 0,
    pasta_buy_counter: 0,
    atom_buy_counter: 0,
    metris_gold_time_active: false,
    notification_top_show: false,
    notification_top_text: '',
    notification_left_show: false,
    notification_left_text: 'Gold Time',
    products: [],
    items: [],
    achievements: []
}

export default _SETTINGS;